import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";

import { SignatureForm } from "../components/signature-form";
import { Dialog } from "../components/ui/dialog";
import { authApi } from "../lib/api";
import { errorMessage, viewerQuery } from "../lib/session";

export const Route = createFileRoute("/_authed/mon-compte")({
  component: AccountPage,
});

function AccountPage() {
  const viewer = useQuery(viewerQuery);
  const email = viewer.data?.user.email;

  return (
    <div className="mx-auto grid max-w-2xl gap-6 px-4 py-8 sm:px-6 sm:py-12">
      <h1 className="text-4xl font-semibold">Mon compte</h1>
      <SignatureForm />
      {email && (
        <section className="panel grid gap-1 p-5">
          <span className="label">Adresse e-mail</span>
          <span>{email}</span>
        </section>
      )}
      <DeleteAccount />
    </div>
  );
}

function DeleteAccount() {
  const queryClient = useQueryClient();
  const [open, setOpen] = useState(false);

  const remove = useMutation({
    mutationFn: authApi.deleteAccount,
    // Same as sign-out: nothing of this account may stay in the cache.
    onSuccess: () => {
      queryClient.clear();
      window.location.href = "/";
    },
  });

  return (
    <section className="panel grid gap-3 p-5">
      <h2 className="text-xl font-semibold">Supprimer mon compte</h2>
      <p className="text-muted">
        Toutes vos listes, leurs envies, leurs réservations et vos photos sont effacées
        définitivement.
      </p>
      <button type="button" className="btn-danger justify-self-start" onClick={() => setOpen(true)}>
        Supprimer mon compte
      </button>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        title="Supprimer votre compte ?"
        description="C'est définitif : rien ne pourra être récupéré."
      >
        <div className="grid gap-4">
          <div
            role="alert"
            className="grid gap-2 rounded-2xl border-2 border-danger bg-danger/10 p-4 text-danger"
          >
            <p className="text-lg font-bold">Attention : tout votre historique sera supprimé.</p>
            <p>
              Toutes vos listes, envies, réservations et photos. Vos proches ne pourront plus ouvrir
              vos listes.
            </p>
          </div>
          <ul className="grid list-disc gap-1 pl-5 text-muted">
            <li>
              Seule exception : une liste partagée avec un co-organisateur reste à cette personne.
            </li>
            <li>Les cadeaux que vous avez réservés pour d'autres restent réservés.</li>
          </ul>
          {remove.isError && (
            <p className="text-danger">
              {errorMessage(remove.error, "Le compte n'a pas pu être supprimé.")}
            </p>
          )}
          <div className="flex flex-wrap gap-2">
            <button
              type="button"
              className="btn-danger"
              onClick={() => remove.mutate()}
              disabled={remove.isPending}
            >
              {remove.isPending ? "Suppression…" : "Supprimer définitivement"}
            </button>
            <button type="button" className="btn-secondary" onClick={() => setOpen(false)}>
              Annuler
            </button>
          </div>
        </div>
      </Dialog>
    </section>
  );
}
